import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pipeCountPlan'
})
export class PipeCountPlan implements PipeTransform {
    constructor() {}
    transform(plans) {
        let t = 0; let d = 0; let p = 0; let i = 0;
        plans.map(p => {
            p.trial ? t++ : p.demo ? d++ : p.provider ? p++ : i++;
        });
        return 'Trial: '+t+' Demo: '+d+' Revenda: '+p+' Interno: '+i;
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeCountPlan.ts